import type { HTMLAttributes, ReactNode } from 'react';
import { Stack } from '../../atoms/Stack/Stack';
import './PageContent.css';

/** narrow ≈ 40rem (forms) · default ≈ 72rem · wide = full available width. */
export type PageContentWidth = 'narrow' | 'default' | 'wide';

export interface PageContentProps extends HTMLAttributes<HTMLDivElement> {
  width?: PageContentWidth;
  children?: ReactNode;
  className?: string;
}

/**
 * PageContent — the content-width container for AppLayout's `main` slot.
 * Centres the page and stacks PageHeader + Sections with var(--spacing-8) rhythm.
 */
export function PageContent({ width = 'default', className = '', children, ...rest }: PageContentProps) {
  return (
    <Stack
      gap="8"
      className={['rg-page-content', `rg-page-content--${width}`, className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </Stack>
  );
}

export default PageContent;
